import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Eye, EyeOff } from "lucide-react";

const StnViewApproval = () => {
   useAuthRedirect();
    const {stnId} = useParams();
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const canView  = hasPermission("STN Requisition Approval", "view");
    const canEdit = hasPermission("STN Requisition Approval", "edit");
    const canDel = hasPermission("STN Requisition Approval", "del");
    


const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchIndentDetails = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/stnApproval_detailsHeader?stnId=${stnId}`
      );

      if (response.data && response.data.headerDetails?.length > 0) {
        const items = response.data.headerDetails;

        const storeReqHeader = {
          stnNumber: items[0].stn_purnumber || "N/A",
          stn_branch: items[0].stn_branch || "N/A",
          stn_now: items[0].stn_now || "N/A",
          stn_dpt: items[0].stn_dpt || "N/A",
          stn_hod: items[0].stn_hod || "N/A",
          stn_requbasis: items[0].stn_requbasis || "N/A",
          stn_headmet: items[0].stn_headmet || "N/A",
          stn_inref: items[0].stn_inref || "N/A",
          stn_remarks: items[0].stn_remarks || "N/A",
        };

        setHeader(storeReqHeader);
        setData(items);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchIndentDetails();
}, [stnId]);

// Delete function with SweetAlert
const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });
        await axios.delete(`https://rfs2.infraconsoft.net.in/api/stn_delete/${id}`);
        setData(data.filter((item) => item.stn_id !== id));

        Swal.fire({
          title: "Deleted!",
          text: "Your record has been deleted.",
          icon: "success"
        });
        navigate("/inventory/stn_approvalview")
      } catch (error) {
        console.error("Error deleting STN Req:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to delete.",
          icon: "error"
        });
      }
    }
  });
};

 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                      <h2 className="add-txt">STN Requisition - View</h2>
                      <Link to="/inventory/stn_approvalview">
                        <p className="back-button">
                          <i className="fa-solid fa-backward"></i>Back
                        </p>
                      </Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>STN Req No :</label>
                <input type="text" name="indentNo" value={header.stnNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text"
                value={header.stn_now ? new Date(header.stn_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>To Branch :</label>
                <input type="text" name="type" value={header.stn_branch} readOnly />
              </div>
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="branch" value={header.stn_dpt} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={header.stn_hod} readOnly/>
              </div>

              <div className="form-group">
                <label>Head Meterial:</label>
                <input type="text"value={header.stn_headmet} readOnly />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Req Basis :</label>
                <input type="text" value={header.stn_requbasis} readOnly/>
              </div>

              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" value={header.stn_inref} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.stn_remarks} readOnly/>
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>
            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                    {showLifeDetail && (
                      <th style={{ textAlign: "center" }}>
                        Life Detail
                      </th>
                    )}
                    {canEdit && (
                    <th>Modify</th>
                    )}
                    {canDel && (
                    <th>Delete</th>
                    )}
                    <th>
                      <button
                        type="button"
                        onClick={() => setShowLifeDetail(!showLifeDetail)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="12" style={{ textAlign: "center" }}>Loading, please wait...</td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.stn_itemcode}</td>
        <td>{item.stn_drawno}</td>
        <td>{item.stn_desc}</td>
        <td>{item.stn_uom}</td>
        <td>{item.stn_price}</td>
        <td>{item.stn_qty}</td>
        <td>{item.stn_duedate ? new Date(item.stn_duedate).toISOString().split("T")[0] : ""}</td>
        <td>{item.stn_specification}</td>
        <td>{item.stn_purpose}</td>
        {showLifeDetail && <td>{item.stn_lifetime}</td>}
        {canEdit && (
          <td>
            <Link to={`/inventory/addstn_neweditapproval/${item.stn_id}`}>
              Edit
            </Link>
          </td>
        )}
        {canDel && (
          <td className="del" onClick={() => handleDelete(item.stn_id)}>
            Delete
          </td>
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="12" style={{ textAlign: "center" }}>No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default StnViewApproval;
